import React from 'react';
import './WorkInProgressScroll.css';

const WorkInProgressScroll: React.FC = () => {
  return (
    <div className="wip-badge">
      <svg viewBox="0 0 100 100" className="wip-badge-svg">
        <defs>
          <path
            id="circlePath"
            d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0"
          />
        </defs>
        <circle cx="50" cy="50" r="45" fill="#ffbb00" />
        <text className="wip-circular-text">
          <textPath href="#circlePath" startOffset="0%">
            Work In Progress • Work In Progress • 
          </textPath>
        </text>
      </svg>
    </div>
  );
};

export default WorkInProgressScroll;
